export { default } from './TimeInput.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/TimeInput/index.js